module.exports = __webpack_public_path__ + "613039dfc96e499c56631fbeed028621.jpg";